import { render } from "./PaymentFeeConfigList.vue?vue&type=template&id=7b2ecc51&scoped=true"
import script from "./PaymentFeeConfigList.vue?vue&type=script&lang=js"
export * from "./PaymentFeeConfigList.vue?vue&type=script&lang=js"

import "./PaymentFeeConfigList.vue?vue&type=style&index=0&id=7b2ecc51&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2ecc51"]])

export default __exports__